import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitoindorecab() {



  const cardData = {
    keyword: " Mumbai to Indore Cab ",


 "headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Indore cab services, ensuring a safe, smooth, and stress-free long-distance journey for families, business travelers, and group passengers. Indore, known as the commercial capital of Madhya Pradesh, is famous for its rich food culture, historic landmarks, and growing business hubs, making it a popular intercity destination from Mumbai. Our professional drivers and well-maintained vehicles ensure a comfortable travel experience throughout the journey. The Mumbai to Indore route covers approximately 580 to 600 km via NH52 and NH160 and takes around 11 to 13 hours depending on traffic, road conditions, and stoppages. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Indore travel.",

  "topPlaces": [
    {
      "title": "Rajwada Palace",
      "description": "Rajwada Palace is a historic seven-story structure located in the heart of Indore, showcasing a blend of Maratha, Mughal, and French architectural styles. It reflects the grandeur of the Holkar dynasty and is a major cultural landmark of the city."
    },
    {
      "title": "Lal Bagh Palace",
      "description": "Lal Bagh Palace is one of the grandest palaces in Indore, known for its European-style architecture, lavish interiors, and beautiful gardens. It offers a glimpse into the luxurious lifestyle of the Holkar rulers."
    },
    {
      "title": "Sarafa Bazaar",
      "description": "Sarafa Bazaar is a famous night street food market in Indore, transforming from a jewelry market during the day into a vibrant food hub at night. It is a must-visit place for food lovers to experience Indore’s unique flavors."
    },
    {
      "title": "Chappan Dukan",
      "description": "Chappan Dukan is a popular food street in Indore featuring 56 shops offering a wide variety of snacks, sweets, and street food. It is one of the best places to explore the city’s rich culinary culture."
    },
    {
      "title": "Kanch Mandir",
      "description": "Kanch Mandir, also known as the Glass Temple, is a Jain temple beautifully decorated with glass panels and mirrors. Its intricate design and spiritual ambiance attract both devotees and tourists."
    },
    {
      "title": "Patalpani Waterfall",
      "description": "Patalpani Waterfall is a scenic natural attraction located near Indore, known for its impressive height and lush surroundings. It is especially popular during the monsoon season and is ideal for picnics and nature lovers."
    },
    {
      "title": "Ralamandal Wildlife Sanctuary",
      "description": "Ralamandal Wildlife Sanctuary is a peaceful nature reserve offering trekking trails and opportunities to spot wildlife like deer and birds. It is a great place for nature enthusiasts and adventure seekers."
    },
    {
      "title": "Annapurna Temple",
      "description": "Annapurna Temple is a famous religious site dedicated to Goddess Annapurna, known for its grand entrance inspired by South Indian architecture and its spiritual significance."
    },
    {
      "title": "Regional Park Indore",
      "description": "Regional Park, also known as Pipliyapala Park, is a well-maintained recreational area featuring gardens, boating facilities, and entertainment options, making it perfect for families and leisure outings."
    },
    {
      "title": "Central Museum Indore",
      "description": "Central Museum Indore houses a rich collection of artifacts, sculptures, and coins from different historical periods. It provides insight into the region’s history and cultural heritage."
    }
  ],






services: [
  {
    name: "Mumbai to Indore Cab",
    description: "Mumbai to Indore cab service offers a comfortable and reliable long-distance journey connecting Maharashtra to Madhya Pradesh’s commercial capital. The route includes smooth highways and scenic landscapes, making travel enjoyable. Ideal for business trips, family visits, and tourism, this service ensures safe and timely travel. Professional drivers and well-maintained vehicles enhance comfort. Multiple car options are available. It guarantees a hassle-free and smooth journey."
  },
  {
    name: "Mumbai to Indore Taxi",
    description: "Mumbai to Indore taxi provides convenient and private transportation with door-to-door pickup and drop. This service is perfect for travelers seeking a comfortable long-distance ride. Vehicles are clean and driven by experienced chauffeurs. Suitable for business and personal travel. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Indore Cab Service",
    description: "Mumbai to Indore cab service is designed for efficient intercity travel with a focus on comfort and safety. The route offers a mix of highways and scenic surroundings. This service is ideal for corporate travel, family trips, and relocation. Vehicles are maintained for long-distance performance. It ensures a dependable journey."
  },
  {
    name: "Mumbai to Indore Taxi Service",
    description: "Mumbai to Indore taxi service offers reliable long-distance transportation with professional drivers and clean vehicles. This service is suitable for families, tourists, and business travelers. Flexible scheduling allows easy travel planning. Door-to-door service adds convenience. It guarantees a hassle-free experience."
  },
  {
    name: "Cab from Mumbai to Indore",
    description: "Cab from Mumbai to Indore provides a personalized travel experience with flexible stops along the route. Travelers can enjoy a comfortable and private journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed road trip experience."
  },
  {
    name: "Taxi from Mumbai to Indore",
    description: "Taxi from Mumbai to Indore offers a convenient and efficient way to travel between the two cities. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for business and leisure travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Indore Cab Booking",
    description: "Mumbai to Indore cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Indore Taxi Booking Online",
    description: "Mumbai to Indore taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Indore Cab Price",
    description: "Mumbai to Indore cab price varies based on vehicle type, travel duration, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Indore Taxi Fare",
    description: "Mumbai to Indore taxi fare is designed to be competitive and flexible for long-distance travel. Fare depends on car type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Indore One Way Cab",
    description: "Mumbai to Indore one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for relocation and business trips. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Indore Round Trip Taxi",
    description: "Mumbai to Indore round trip taxi is ideal for travelers planning a return journey. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family and corporate travel. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Indore Innova Cab",
    description: "Mumbai to Indore Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space for long journeys. Ideal for multi-day travel. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Indore Ertiga Cab",
    description: "Mumbai to Indore Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Indore Sedan Cab",
    description: "Mumbai to Indore sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for long-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Indore SUV Taxi",
    description: "Mumbai to Indore SUV taxi provides extra space and comfort for group travel across long distances. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Indore Cab",
    description: "Cheap Mumbai to Indore cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Indore Taxi Service",
    description: "Best Mumbai to Indore taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Indore Cab", "Mumbai to Indore Taxi"],
  ["Mumbai to Indore Cab Service", "Mumbai to Indore Taxi Service"],
  ["Cab from Mumbai to Indore", "Taxi from Mumbai to Indore"],
  ["Mumbai to Indore Cab Booking", "Mumbai to Indore Taxi Booking Online"],
  ["Mumbai to Indore Cab Price", "Mumbai to Indore Taxi Fare"],
  ["Mumbai to Indore One Way Cab", "Mumbai to Indore Round Trip Taxi"],
  ["Mumbai to Indore Innova Cab", "Mumbai to Indore Ertiga Cab"],
  ["Mumbai to Indore Sedan Cab", "Mumbai to Indore SUV Taxi"],
  ["Cheap Mumbai to Indore Cab", "Best Mumbai to Indore Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Indore Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Indore cab service, ideal for business trips, family travel, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Indore routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Indore cab service operates 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel options for Indore trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Indore cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Indore cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Indore for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Indore?", answer: "The distance is approximately 580 to 600 km and takes around 10 to 12 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Indore cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance trips like Mumbai to Indore." },
  { question: "Do you provide night travel service?", answer: "Yes, we provide safe night travel with experienced drivers." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Malhotra",
    feedback: "The Mumbai to Indore cab journey with Royal Route Cabs was very smooth and comfortable. The driver was professional and ensured a safe long-distance travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Verma",
    feedback: "Excellent experience traveling from Mumbai to Indore. The cab was clean, the ride was comfortable, and the service felt reliable throughout the journey.",
    rating: 5
  }
];

















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Indore Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-indore-cab.jpg", // replace if needed
  "description": "Book Mumbai to Indore cab with Royal Route Cabs for a safe, comfortable, and affordable long-distance journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability and experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-indore-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Indore Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Indore cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to indore cab, mumbai to indore taxi, mumbai to indore cab service, mumbai to indore taxi service, cab from mumbai to indore, taxi from mumbai to indore, mumbai to indore cab booking, mumbai to indore taxi booking online, mumbai to indore cab price, mumbai to indore taxi fare, mumbai to indore one way cab, mumbai to indore round trip taxi, mumbai to indore innova cab, mumbai to indore ertiga cab, mumbai to indore sedan cab, mumbai to indore suv taxi, cheap mumbai to indore cab, best mumbai to indore taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoindorecab;